const staticUrl = () => {
  let sUrl;
  const pathname = window.location.host.toLowerCase();
  const version = document.getElementById('ms_rangers_version').value;
  if (pathname.indexOf('thecoachingmanual.com') > -1) {
    sUrl = `https://cdn.thecoachingmanual.com/ms-rangers/${version}/`;
  } else if (pathname.indexOf('beans.youballer.io') > -1) {
    sUrl = `https://cdn.beans.youballer.io/ms-rangers/${version}/`;
  } else {
    sUrl = '/';
  }
  return sUrl;
};

export default staticUrl;



// WEBPACK FOOTER //
// ./library/js/modules/static-path.js